import { Text } from '@lili/lili-frontend-common';
import React from 'react';
import { convertValueToUSDv2 } from '../../../helpers/currency.helper';
import { ReactComponent as Icon } from '../../../assets/icons/svg/shared/ic-shared-blurbg-password.svg';
import { Limit } from '../AccountLimitsType';

interface LimitListRowProps {
  cell1: string;
  cell2: Limit[];
  cell3: Limit[];
}

export const LimitsListRow = ({ cell1, cell2, cell3 }: LimitListRowProps) => (
  <div id='row' className='py-[29px] pl-[24px] flex items-center w-full h-[74px] border-t  border-bw03'>
    <div id='transcation-type' className='w-[188px] flex items-center justify-start'>
      <Text.H10>{cell1}</Text.H10>
    </div>
    <div id='freq' className='w-[101px] px-[12px] flex flex-col items-start justify-start'>
      {cell2.map((limit, index) => (
        <Text.H10 className={`text-text-main-secondary ${index > 0 ? 'pt-2' : ''}`}>{limit.name}</Text.H10>
      ))}
    </div>
    <div id='current-limit' className='min-w-[91px] pr-[12px] justify-start flex flex-col'>
      {cell3.map((limit, index) => (
        <Text.H10 className={`text-text-main-secondary ${index > 0 ? 'pt-2' : ''}`}>
          {`$${convertValueToUSDv2(limit.currentTierValue)}`}
        </Text.H10>
      ))}
    </div>
    <div id='new-limit' className='relative w-[100px] flex justify-center items-center'>
      <div className='absolute flex flex-col'>
        {cell3.map(() => (
          <span className=' text-[16px]  font-bold opacity-50 blur-sm select-none pointer-events-none'>hidden</span>
        ))}
      </div>

      <Icon />
    </div>
  </div>
);
